export default "__VITE_ASSET__B1ELaPv0__"